"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.navList = exports.navEdit = exports.navDel = exports.navCode = exports.navAdd = void 0;
var _api = _interopRequireDefault(require("_l/api.request"));
/**
 * 描述 获取导航列表
 * @author kkdy
 * @date 2021-11-23
 * @param {any} data
 * @returns {any}
 */
var navList = exports.navList = function navList(data) {
  return _api.default.request({
    url: '/router/navigationList',
    method: 'post',
    data: data
  });
};
/**
 * 描述 通过省份编码获取导航
 * @author kkdy
 * @date 2021-12-01
 * @param {any} data
 * @returns {any}
 */
var navCode = exports.navCode = function navCode(data) {
  return _api.default.request({
    url: '/web/getNavigations',
    method: 'post',
    data: data
  });
};
/**
 * 描述 新增导航
 * @author kkdy
 * @date 2021-11-24
 * @param {any} data
 * @returns {any}
 */
var navAdd = exports.navAdd = function navAdd(data) {
  return _api.default.request({
    url: '/router/saveNavigation',
    method: 'post',
    data: data
  });
};
/**
 * 描述 删除导航
 * @author kkdy
 * @date 2021-11-25
 * @param {any} data
 * @returns {any}
 */
var navDel = exports.navDel = function navDel(data) {
  return _api.default.request({
    url: '/router/removeNavigation',
    method: 'post',
    data: data
  });
};
/**
 * 描述 修改导航
 * @author kkdy
 * @date 2021-11-25
 * @param {any} data
 * @returns {any}
 */
var navEdit = exports.navEdit = function navEdit(data) {
  return _api.default.request({
    url: '/router/editNavigation',
    method: 'post',
    data: data
  });
};